(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["engraving-builder"] && !Shopify.designMode) return;
  try {
    const EngravingBuilder = class extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('[role="tab"]')
        this.tabPanels = this.querySelectorAll('[role="tabpanel"]')
        this.selectedFontInput = this.querySelector('[data-selected-font]')
        this.fontPickers = this.querySelectorAll('[data-engraving-font]')
        this.textareas = this.querySelectorAll('textarea')
    }

    connectedCallback() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                this.handleTabClick(e);
            });
        });

        this.fontPickers.forEach((fontPicker) => {
            fontPicker.addEventListener('input', (e) => {
                const selectedFont = e.target.value;
                const cssFont = e.target.dataset.cssFont || selectedFont;
                this.updateFont(selectedFont, cssFont);
            })
        })

        this.textareas.forEach((textarea) => {
            this.updateCharacterCount(textarea);
            textarea.addEventListener('input', (e) => {
                this.sanitizeTextarea(textarea);
                this.updateCharacterCount(textarea);
            });
        });

        this.querySelectorAll('[data-engraving-icon]').forEach((icon) => {
            icon.addEventListener('click', (e) => {
                this.addIconToTextarea(e.currentTarget);
            });
        });
    }

    handleTabClick(e) {
        const targetTab = e.currentTarget;
        const targetPanelId = targetTab.getAttribute('aria-controls');
        const targetPanel = this.querySelector(`#${targetPanelId}`);

        this.tabs.forEach((tab) => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
            tab.classList.add('!text-fg-muted','opacity-75')
        });

        this.tabPanels.forEach((panel) => {
            panel.classList.add('hidden');
        });

        targetTab.setAttribute('aria-selected', 'true');
        targetTab.classList.remove('!text-fg-muted', 'opacity-75');
        targetTab.setAttribute('tabindex', '0');
        targetPanel.classList.remove('hidden');
    }

    addIconToTextarea(icon) {
        const visibleTextArea = Array.from(this.textareas).find(textarea => !textarea.classList.contains('hidden'));
        if (!visibleTextArea) return;

        const maxLength = visibleTextArea.maxLength;
        const remainingLength = maxLength < 0 ? Infinity : maxLength - visibleTextArea.value.length;
        // Icons like ☀︎ are two characters (symbol + U+FE0E), never add half of one
        if (icon.textContent.length > remainingLength) return;

        visibleTextArea.value += icon.textContent;
        visibleTextArea.dispatchEvent(new Event('input'));
    }

    updateCharacterCount(textarea) {
        const count = textarea.parentElement.querySelector('[data-characters]');
        if (count) count.textContent = textarea.value.length;
    }

    sanitizeTextarea(textarea) {
        // Pictographs followed by U+FE0E (text presentation) are allowed, e.g. the \u2600\uFE0E and \u271D\uFE0E icon buttons
        const disallowedPattern = /\p{Extended_Pictographic}(?!\uFE0E)|[\p{Regional_Indicator}\u200D\uFE0F\u20E3]/gu;
        const errorMessage = textarea.parentElement.querySelector('[data-emoji-error]');
        const hasDisallowedCharacters = disallowedPattern.test(textarea.value);

        if (errorMessage) {
            errorMessage.classList.toggle('hidden', !hasDisallowedCharacters);
        }

        if (!hasDisallowedCharacters) return;

        // Removes disallowed characters
        textarea.value = textarea.value.replace(disallowedPattern, '');
    }

    updateFont(selectedFont, cssFont) {
        this.selectedFontInput.value = selectedFont;
        this.tabPanels.forEach((panel) => {
            const textarea = panel.querySelector('textarea');
            textarea.style.fontFamily = `'${cssFont}',${selectedFont}`;
        });
        this.querySelectorAll('[data-engraving-icon]').forEach((icon) => {
            icon.style.fontFamily = `'${cssFont}',${selectedFont}`;
        });
    }
}

customElements.define('engraving-builder', EngravingBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geolocation-popup"] && !Shopify.designMode) return;
  try {
    class GeoPopup extends HTMLElement {
    static COOKIE = 'geo_country';
    static DAYS = 30;
    static API = 'https://get.geojs.io/v1/ip/country.json';
    static CACHE_KEY = 'geo_detected_country';

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-geo-trigger]');
      this.options = this.querySelector('[data-geo-options]');
      this.display = this.querySelector('[data-geo-trigger-display]');
      this.allOptions = this.querySelectorAll('[data-geo-option]');
      this.currentCountry = this.dataset.currentCountry;
      this.selected = null;
      this.supportsPopover = typeof this.options.showPopover === 'function';
      this.optionsOpen = false;

      this.querySelector('[data-geo-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-geo-confirm]')?.addEventListener('click', () => this.confirm());
      this.querySelector('[data-geo-continue]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.close();
      });

      if (this.supportsPopover) {
        this.options.addEventListener('beforetoggle', (e) => {
          this.optionsOpen = e.newState === 'open';
          if (this.optionsOpen) this.positionOptions();
        });
      } else {
        this.options.removeAttribute('popover');
        this.options.classList.add('geo-popup__options--fallback');
        this.trigger.removeAttribute('popovertarget');
        this.trigger.addEventListener('click', () => this.toggleOptions());
        this._onDocClick = (e) => {
          if (!this.options.contains(e.target) && !this.trigger.contains(e.target)) this.hideOptions();
        };
        this._onDocKey = (e) => {
          if (e.key === 'Escape') this.hideOptions();
        };
      }

      this.allOptions.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.selectOption(btn);
          this.hideOptions();
        });
      });

      const defaultOption =
        this.querySelector(`[data-geo-option][data-iso="${this.currentCountry}"]`) ?? this.allOptions[0];
      if (defaultOption) this.selectOption(defaultOption);

      this.run();
    }

    positionOptions() {
      const rect = this.trigger.getBoundingClientRect();
      Object.assign(this.options.style, {
        left: `${rect.left}px`,
        top: `${rect.bottom}px`,
        width: `${rect.width}px`,
      });
    }

    toggleOptions() {
      this.optionsOpen ? this.hideOptions() : this.showOptions();
    }

    showOptions() {
      if (this.supportsPopover) {
        this.options.showPopover();
        return;
      }
      this.positionOptions();
      this.options.classList.add('is-open');
      this.optionsOpen = true;
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onDocKey);
    }

    hideOptions() {
      if (this.supportsPopover) {
        if (this.optionsOpen) this.options.hidePopover();
        return;
      }
      if (!this.optionsOpen) return;
      this.options.classList.remove('is-open');
      this.optionsOpen = false;
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onDocKey);
    }

    selectOption(btn) {
      this.allOptions.forEach((o) => o.classList.toggle('is-selected', o === btn));
      this.selected = btn;

      const img = btn.querySelector('img');
      this.display.replaceChildren(
        ...(img ? [img.cloneNode(true)] : []),
        Object.assign(document.createElement('span'), { textContent: btn.dataset.name })
      );
    }

    async run() {
      const params = new URLSearchParams(window.location.search);

      if (params.has('geolocation_pick')) {
        this.writeCookie(this.currentCountry, GeoPopup.DAYS);
        this.cleanParam('geolocation_pick', params);
        return;
      }

      const forced = params.has('force_geo_popup');
      if (forced) {
        this.writeCookie('', 0);
        this.cleanParam('force_geo_popup', params);
      }

      if (!forced && this.getCookie()) return;

      const detected = await this.detect();
      if (!detected) return;

      if (!forced && detected === this.currentCountry) {
        this.writeCookie(this.currentCountry, GeoPopup.DAYS);
        return;
      }

      const proposedMarket = this.getProposedMarket(detected)
      if(proposedMarket === this.currentCountry) return
      console.log("[localization] - Proposed market:", proposedMarket)

      if (this.preselectMarket(detected)) this.open();
    }

    getProposedMarket(countryCode) {
      const code = countryCode.toUpperCase();
      const options = Array.from(this.allOptions);
      const match =
        options.find((o) =>
          (o.dataset.iso || '')
            .split(',')
            .map((s) => s.trim())
            .includes(code)
        ) ?? options.find((o) => !o.dataset.iso?.trim());
      if(!match) return null
      return match.dataset.iso.trim() || 'EU'
    }

    preselectMarket(countryCode) {
      const code = countryCode.toUpperCase();
      const options = Array.from(this.allOptions);

      const match =
        options.find((o) =>
          (o.dataset.iso || '')
            .split(',')
            .map((s) => s.trim())
            .includes(code)
        ) ?? options.find((o) => !o.dataset.iso?.trim());
      if (!match) return false;

      const item = match.closest('li');
      item?.parentElement?.prepend(item);

      this.selectOption(match);
      return true;
    }

    async detect() {
      const cached = sessionStorage.getItem(GeoPopup.CACHE_KEY);
      if (cached) return cached;
      try {
        const res = await fetch(GeoPopup.API);
        const { country } = await res.json();
        const code = country?.toUpperCase();
        if (code) sessionStorage.setItem(GeoPopup.CACHE_KEY, code);
        return code ?? null;
      } catch {
        return null;
      }
    }

    open() {
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      if (!this.dialog.open) return;
      this.hideOptions();
      this.writeCookie(this.currentCountry, GeoPopup.DAYS);
      this.dialog.classList.remove('is-open');
      setTimeout(() => this.dialog.close(), 250);
    }

    confirm() {
      if (!this.selected) {
        this.close();
        return;
      }

      const href = this.selected.dataset.href?.trim();
      if (!href || new URL(href).origin === window.location.origin) {
        this.close();
        return;
      }

      const alternate = document.querySelector(`link[rel="alternate"][hreflang][href^="${href}"]`);
      const destination = new URL(alternate?.href ?? href);
      destination.searchParams.set('geolocation_pick', 'true');
      window.location.href = destination.href;
    }

    getCookie() {
      return (
        document.cookie
          .split('; ')
          .find((c) => c.startsWith(`${GeoPopup.COOKIE}=`))
          ?.split('=')[1] ?? null
      );
    }

    writeCookie(value, days) {
      document.cookie = `${GeoPopup.COOKIE}=${value}; max-age=${days * 86400}; path=/`;
    }

    cleanParam(key, params) {
      params.delete(key);
      const qs = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (qs ? `?${qs}` : ''));
    }
  }

  if (!customElements.get('geo-popup')) {
    customElements.define('geo-popup', GeoPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gowish-code-snippet"] && !Shopify.designMode) return;
  try {
    const gowishButton = document.getElementById('gowishBlueButton');
  if (gowishButton) {
    gowishButton.addEventListener('click', function () {
      Shopify.analytics.publish('product_added_to_onskeskyen');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
